<template>
  <section class="l-content">
    <el-card>
      <el-form :inline="true" :model="condition">
        <el-form-item>
          <el-input v-model="condition.keyword" placeholder="工人姓名/手机号" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getPageData()">查询</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-divider></el-divider>
    <el-card v-if="pageData">
      <l-table :option="tableOption" :data="pageData.list" :start-index="pageData.startIndex">
        <template slot="worker_name" slot-scope="scope">
          <i v-if="scope.row.user_id" class="el-icon-mobile-phone text-primary" style="margin-right: 5px; color: #409EFF;"></i>
          {{ scope.row.worker_name }}
        </template>
        <template slot="is_enabled" slot-scope="scope">
          <el-tag :type="scope.row.is_enabled ? 'success' : 'danger'">
            {{ scope.row.is_enabled ? '启用' : '禁用' }}
          </el-tag>
        </template>
      </l-table>
      <l-pager :page="pageData" @change="getPageData"></l-pager>
    </el-card>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import workerEdit from './workerEdit.vue'

export default {
  computed: {
    ...mapState(['userInfo'])
  },
  name: 'CleanWorkerList',
  data() {
    return {
      tableOption: {
        stripe: true,
        height: document.documentElement.clientHeight - 280 + 'px',
        columns: [
          { label: '序号', type: 'index', width: 60 },
          { label: '工人姓名', slot: 'worker_name', width: 140 },
          { label: '联系电话', prop: 'worker_phone', width: 160 },
          { label: '状态', slot: 'is_enabled', width: 80 },
          { label: '创建时间', prop: 'create_time', width: 160 },
          { label: '备注', prop: 'remark' }
        ],
        operation: {
          width: '260',
          header: { type: 'primary', icon: 'el-icon-plus', label: '新增工人', click: this.add },
          buttons: [
            { type: 'primary', icon: 'el-icon-edit', label: '修改', click: this.edit },
            { type: 'danger', icon: 'el-icon-delete', label: '删除', click: this.del }
          ]
        }
      },
      condition: {
        keyword: '',
        pageIndex: 1,
        pageSize: 15
      },
      pageData: null
    }
  },
  created() {
    this.getPageData()
  },
  methods: {
    async getPageData(pageOption) {
      Object.assign(this.condition, pageOption)
      this.pageData = await this.$lgh.get('api/clean/worker/page', {
        enterpriseCode: this.userInfo.enterpriseCode,
        keyword: this.condition.keyword,
        pageIndex: this.condition.pageIndex,
        pageSize: this.condition.pageSize
      })
    },
    async add() {
      await this.$lgh.openDialog({
        ins: workerEdit,
        title: '新增保洁工人',
        data: {
          isAdd: true,
          dataInfo: {}
        }
      })
      this.$lgh.notifySuccess('新增成功', '新增保洁工人成功')
      this.getPageData()
    },
    async edit(item) {
      await this.$lgh.openDialog({
        ins: workerEdit,
        title: '修改保洁工人',
        data: {
          isAdd: false,
          dataInfo: Object.assign({}, item)
        }
      })
      this.$lgh.notifySuccess('修改成功', '修改保洁工人成功')
      this.getPageData()
    },
    del(item) {
      this.$lgh.msgConfirm('确认删除该工人?', async () => {
        await this.$lgh.get('api/clean/worker/delete', { workerId: item.worker_id })
        this.$lgh.notifySuccess('删除成功', '删除保洁工人成功')
        this.getPageData()
      })
    }
  }
}
</script>
